import { UserInfo } from "@/utils/userinfo/types";

export function useVerifySendCode(isDomestic: boolean, userInfo?: UserInfo) {
  const handleSendCode = (
    sendCode: ({ url, params }: { url: string; params: object }) => void
  ) => {
    const url = isDomestic
      ? "/api/rendering/user/validate/sendAccessKeyCode"
      : "/api/rendering/user/sendEmailCode";
    if (!userInfo) return;
    const { userName, email, phone } = userInfo;
    const params = isDomestic
      ? {
          phone,
          type: 1,
        }
      : {
          userName,
          email: email?.toLowerCase(),
          business: 9,
        };
    sendCode({
      url,
      params,
    });
  };

  return {
    handleSendCode,
  };
}
